// extracted by mini-css-extract-plugin
module.exports = {"SideBarButton":"SideBarButton_SideBarButton__3ZKZ_","SideBarButtonIcon":"SideBarButton_SideBarButtonIcon__35Hxs"};